/**
 * Profile top bar (specs/profile-page AC-3): back control, "Profile" title, settings gear.
 * The gear opens the existing global menu (no new settings screen).
 */

import React from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import { ArrowLeft, Settings } from 'lucide-react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../shared/constants/animations';
import { PROFILE_COLORS, PROFILE_TEST_IDS } from '../ProfileScreen/ProfileScreen.constants';
import { profileHeaderBarStyles as styles } from './ProfileHeaderBar.styles';

export interface ProfileHeaderBarProps {
  onBack: () => void;
  onOpenSettings: () => void;
  testID?: string;
}

export const ProfileHeaderBar: React.FC<ProfileHeaderBarProps> = ({ onBack, onOpenSettings, testID }) => (
  <View style={styles.bar} testID={testID}>
    <Pressable
      onPress={onBack}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      accessibilityRole="button"
      accessibilityLabel="Go back"
      testID={PROFILE_TEST_IDS.back}
      style={({ pressed, hovered }) => [
        styles.iconButton,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.iconButtonPressed,
        hovered && Platform.OS === 'web' && styles.iconButtonHover,
      ]}
    >
      <ArrowLeft size={22} color={PROFILE_COLORS.text} strokeWidth={2} />
    </Pressable>

    <Text style={styles.title}>Profile</Text>

    <Pressable
      onPress={onOpenSettings}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      accessibilityRole="button"
      accessibilityLabel="Open menu"
      testID={PROFILE_TEST_IDS.settings}
      style={({ pressed, hovered }) => [
        styles.iconButton,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.iconButtonPressed,
        hovered && Platform.OS === 'web' && styles.iconButtonHover,
      ]}
    >
      <Settings size={20} color={PROFILE_COLORS.text} strokeWidth={2} />
    </Pressable>
  </View>
);
